export enum AgreementEligibilityCode {
    STATUS_ELIGIBLE = -1, // user elegivel para simulação
    STATUS_OPEN = 0, // simulação pedida - aguarda resposta 1
    STATUS_APROVED = 1, // simulação efetuada com sucesso -  resposta 1 recebida
    STATUS_WAITING_ACCEPTANCE = 2, // confirmação pedida - aguarda resposta 2
    STATUS_ACCEPTED = 3, // confirmação recebida com sucesso - resposta 2 recebida
    STATUS_CLOSED = 4, // pedido terminado
    STATUS_EXPIRED = 5, // pedido expirado
    STATUS_ERROR = 6, // pedido em erro
    STATUS_CANCELED = 7, // pedido cancelado
}
